import exploreSvg from '@h2/assets/svg/illustrations/explore.svg'
import { Promotion } from '@h2/features/dashboard/promotion'

const PromotionCard = ({ nextStep }) => {
  return (
    <Promotion color="blue" variant="promotion">
      <Promotion.PreHeading>
        {nextStep.nonTemplateDetails.preHeading}
      </Promotion.PreHeading>
      <Promotion.Heading>{nextStep.nonTemplateDetails.heading}</Promotion.Heading>
      <Promotion.Text>{nextStep.nonTemplateDetails.body}</Promotion.Text>
      <Promotion.Button
        href={nextStep.nonTemplateDetails.url}
        size="large"
        style={{ fontSize: '18px' }}>
        {nextStep.nonTemplateDetails.buttonTitle}
      </Promotion.Button>
      <Promotion.Image src={exploreSvg} />
    </Promotion>
  )
}

export { PromotionCard }
